import { Component } from '@angular/core';

@Component({
  selector: 'left-nav-skeleton',
  templateUrl: './left-nav-skeleton.component.html',
  standalone: false,
})
export class LeftNavSkeletonComponent {}
